import ProductConnector from './product.props';
import ProductComponent from './product.component';

export default ProductConnector(ProductComponent);
